import React, { useEffect, useState } from "react";
import { TextField, 
  OutlinedInput, 
  InputLabel, 
  FormControl, 
  InputAdornment, 
  IconButton, Button } from "@mui/material";
import * as _ from 'lodash'

const MainCardInfo = (props) => {

  const [isEdit, setIsEdit] = useState(false)
  const [data, setData] = useState({})
  const [cardNumber, setCardNumber] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const onSubmit = () => {
    if (!_.isEmpty(cardNumber) && !_.isEmpty(password)) {
      setData({cardNumber, password})
    }
    setIsEdit(false)
  }

  const onCancel = () => {
    setCardNumber(_.get(data, 'cardNumber', ''))
    setPassword(_.get(data, 'password', ''))
    setIsEdit(false)
  }

  const isButtonEnabled = () => {
    return _.isEmpty(cardNumber) || _.isEmpty(password)
  }

  useEffect(() => {
    if (_.isEmpty(data)) return
    setCardNumber(data.cardNumber ?? '')
    setPassword(data.password ?? '')
  }, [data])

  return (
    <div className="bordered bg-light p-4 mt-4">
      <div className="d-flex justify-content-between">
        <span className="font-size-20 font-weight-bold ps-3">
          Толгой картын мэдээлэл
        </span>
        {
          !isEdit ? <button className="fab-btn" onClick={() => setIsEdit(true)}>
            <img alt="edit" src="/images/edit.svg" height={16}/>
          </button> : <div className="d-flex">
            <button className="fab-btn" onClick={onCancel}>
              <img alt="close" src="/images/close.svg" height={11}/>
            </button>
            <button disabled={isButtonEnabled()} className="fab-btn bg-primary border-none me-2" onClick={onSubmit}>
              <img alt="btn" src={isButtonEnabled() ? "/images/check.svg" : "/images/check_white.svg"} height={13}/>
            </button>
          </div>
        }
      </div>
      {!_.isEmpty(data) || isEdit ? 
        <>
          {
            isEdit ? 
              <TextField 
                className="mt-4 mb-2 w-100" 
                label="Картын дугаар" 
                variant="outlined"
                value={cardNumber}
                onChange={(e) => setCardNumber(e.target.value)}
              /> : 
              <div className="mt-4">
                <div className="font-size-12 text-grey">КАРТЫН ДУГААР</div>
                <div className="font-size-16">{cardNumber}</div>
              </div>
          }
          <div className="mt-3">
            <div className="font-size-12 text-grey">КАРТЫН ҮЛДЭГДЭЛ</div>
            <div className="font-size-16">12’000’000₮</div>
          </div>
          <hr className="mt-3" />
          {
            isEdit ? 
              <FormControl className="w-100 mt-1" variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">Нэвтрэх нууц үг</InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <i className='bx bx-show font-size-16'></i> : <i className='bx bx-low-vision font-size-16'></i>}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Нэвтрэх нууц үг"
                />
              </FormControl> : 
              <div className="mt-3">
                <div className="font-size-12 text-grey">НЭВТРЭХ НУУЦ ҮГ</div>
                <div className="font-size-16">
                  {
                    password.length > 0 ? Array.from({length: password.length}).map( (_, index) => {
                      return '*';
                    }).join('').match(/.{1,3}/g).join(' ') : ''
                  }
                </div>
            </div>
          }
        </> : 
        <div className="dotted-container mt-4">
          <img alt="add" src="/images/add_rounded.svg" height={27}/>
          <div className="text-grey font-size-12 text-center font-weight-500 mt-2">
            Уг хэсэгт мэдээлэл байхгүй байгаа <br />
            тул мэдээлэл оруулж өгнө үү
          </div>
          <Button 
            onClick={() => setIsEdit(true)}
            className="bg-primary btn-bordered mt-4 px-4" 
            variant="contained" 
            disableElevation>
            Мэдээлэл оруулах
          </Button>
        </div>
      }
    </div>
  );
};

export default MainCardInfo;
